<template>
  <div class="document-debug">
    <div>
      <el-input placeholder="" v-model="url">
        <template slot="prepend">GET</template>
        <el-button
          slot="append"
          class="send-btn"
          @click="sendReq"
          v-loading="loading"
        >
          发送
        </el-button>
      </el-input>
    </div>
    <div class="tabClass">
      <el-tabs v-model="activeMeau" @tab-click="handleClick">
        <el-tab-pane label="请求参数" name="reqParams" class="paramclass">
          <template v-if="parameter.length > 0">
            <!-- <el-radio-group v-model="sendWay" v-if="false">
              <div class="topradio">
                <el-radio :label="1">x-www-form-urlencoded</el-radio>
                <el-radio :label="2">raw</el-radio>
              </div>
            </el-radio-group> -->
            <div v-if="sendWay == 1" class="form-urlencoded">
              <div class="headerClass">
                <table border="0" cellPadding="30">
                  <tr style="height: 30px; background-color: #f7f8f8">
                    <td>
                      <input type="checkbox" v-model="isCheckAllParams" @change="checkAllParams()" />
                    </td>
                    <td style="margin-left: 13px; display: inline-block">
                      参数名称
                    </td>
                    <td>参数值</td>
                    <!-- <td>操作</td> -->
                  </tr>
                  <tr v-for="(item, index) in parameter" :key="index">
                    <td width="30px">
                      <input
                        type="checkbox"
                        v-model="paramChecks[index]"
                        @change="checkParam()"
                      />
                      <span v-if="item.required === '必填'" style="color: red">*</span>
                    </td>
                    <td>
                      <input type="text" v-model="item.paras" class="input1" disabled/>
                    </td>
                    <td>
                      <select
                        v-if="item.option && item.option.length > 0"
                        v-model="item.value"
                        class="input2"
                      >
                        <option disabled selected value>- {{ item.description.split('##')[0] }}</option>
                        <option
                          v-for="(oItem, oIndex) in item.option"
                          :key="oIndex"
                          :value="oItem"
                        >
                        {{ oItem }}
                        </option>
                      </select>
                      <input
                        v-else
                        type="text"
                        :placeholder="item.description"
                        class="input2"
                        v-model="item.value"
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="headerClass">无参数</div>
          </template>
        </el-tab-pane>
        <el-tab-pane label="请求头部" name="reqHeader" class="requestclass" v-if="false">
          <div class="headerClass">
            <table border="0" cellPadding="30">
              <tr style="height: 30px; background-color: #f7f8f8">
                <td>
                  <input type="checkbox" v-model="isCheckAllHeader" @change="checkAllHeader()" />
                </td>
                <td style="margin-left: 13px; display: inline-block">请求头</td>
                <td>内容</td>
                <!-- <td>操作</td> -->
              </tr>
              <tr v-for="(item, index) in headerList" :key="index">
                <td>
                  <input
                    type="checkbox"
                    v-model="headerChecks[index]"
                    @change="checkHeader()"
                  />
                </td>
                <td>
                  <input type="text" class="input1" v-model="item.paras" />
                </td>
                <td>
                  <input type="text" placeholder="请求头内容" class="input2" v-model="item.value"/>
                </td>
              </tr>
            </table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="返回结果" name="response" class="responseclass">
          <div style="height: 500px">
            <codemirror
              ref="cm"
              v-model="code"
              :options="cmOption"
            >
            </codemirror>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/go/go.js";
import "codemirror/mode/php/php.js";
import "codemirror/mode/vb/vb.js";
import "codemirror/mode/python/python.js";
import "codemirror/theme/darcula.css";
import "codemirror/addon/selection/active-line.js";
import devToolMixin from '../mixins/devToolMixin'
import { apiData } from "../apiData";
import util from '@/utils/util'

export default {
  mixins: [devToolMixin],
  computed: {
    ...mapGetters(['userinfo'])
  },
  components: {
    codemirror
  },
  props: {
    keyName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sendWay: 1,
      activeMeau: "reqParams",
      parameter: [],
      headerList: [],
      url: "",
      headerChecks: [],
      reqWay: 'GET',
      paramChecks: [],
      isCheckAllHeader: true,
      isCheckAllParams: true,
      code: '',
      cmOption: {
        tabSize: 4,
        readOnly: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: "text/x-go",
        lineWrapping: true,
        theme: "darcula",
      },
      loading: false
    };
  },
  watch: {
    keyName: {
      handler: function (newValue, oldValue) {
        this.parameter = this.dealParams(apiData[newValue].yWRequestParamsTable.tableData);
        this.headerList = this.dealParams(apiData[newValue].requestHeadParamsTable.tableData);
        this.url = apiData[newValue].interfaceInfoTable.tableData[0].url;
        this.reqWay = apiData[newValue].interfaceInfoTable.tableData[0].way;
        this.paramChecks = new Array(this.parameter.length).fill(true);
        this.headerChecks = new Array(this.headerList.length).fill(true);
        this.activeMeau = "reqParams";
        setTimeout(() => {
          this.code = '';
          this.$refs.cm && this.$refs.cm.refresh()
        }, 2000);
      },
      immediate: true,
    },
    url:{
       handler(newVal,oldVal){
         if(newVal !== oldVal){
           this.activeMeau = 'reqParams';
         }
       },
       immediate: true,
    },
    headerChecks: function (val) {
      if (val.length) {
        this.isCheckAllHeader = val.every(function (item) {
          return item == true;
        });
      } else {
        this.isCheckAllHeader = false;
      }
    },
    paramChecks: function (val) {
      if (val.length) {
        this.isCheckAllParams = val.every(function (item) {
          return item == true;
        });
      } else {
        this.isCheckAllParams = false;
      }
    },
  },
  methods: {
    dealParams(arr) {
      let res = arr.filter(element => {
        return element.paras !== '无';
      }).map(item => {
        return {
          ...item,
          value: ''
        }
      });
      return res;
    },
    checkHeader: function () {
      console.log(this.headerChecks);
    },
    checkParam: function () {
      console.log(this.paramChecks);
    },
    checkAllHeader: function () {
      if (this.isCheckAllHeader) {
        for (let i = 0; i < this.headerChecks.length; i++) {
          this.headerChecks[i] = true;
        }
      } else {
        for (let i = 0; i < this.headerChecks.length; i++) {
          this.headerChecks[i] = false;
        }
      }
    },
    checkAllParams: function () {
      if (this.isCheckAllParams) {
        for (let i = 0; i < this.paramChecks.length; i++) {
          this.paramChecks[i] = true;
        }
      } else {
        for (let i = 0; i < this.paramChecks.length; i++) {
          this.paramChecks[i] = false;
        }
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    sendReq() {
      if (!this.userinfo.clientId) {
        this.$router.push({path: '/front/login'});
        return;
      }
      let params = {};
      this.paramChecks.forEach((item, index) => {
        if (item) {
          let {
            paras,
            value,
            type
          } = this.parameter[index]
          params[paras] = (type === 'Number' ? +value : value);
        }
      })
      if (this.loading) {
        return;
      }
      let isVaild = true;
      for (let i = 0; i < this.parameter.length; i++) {
        if (this.parameter[i].required === '必填' && !params[this.parameter[i].paras]) {
          isVaild = false;
          break;
        }
      }
      if (!isVaild) {
        this.$message.warning('请输入必填参数');
        this.activeMeau = 'reqParams'
        return;
      }
      this.loading = true;
      this.sendDevRequest(this.url, params, this.reqWay).then(res => {
        if (typeof res === 'string') {
          this.code = util.isJsonString(res) ? JSON.stringify(JSON.parse(res), null, '\t') : res;
        }
        else {
          this.code = JSON.stringify(res, null, '\t');
        }
        this.activeMeau = 'response'
      }).catch(e => {
        this.$message.error((e && e.msg) || '接口异常，请稍后重试');
      }).finally(() => {
        setTimeout(() => {
          // 加个防抖
          this.loading = false;
        }, 500);
      })
    }
  },
};
</script>
<style lang="scss">
.document-debug {
  .el-input {
    width: 700px;
  }
  .el-tabs__active-bar {
    width: 56px !important;
  }
}
</style>
<style lang="scss" scoped>
.document-debug {
  .send-btn {
    background-color: #3855f5;
    color: #fff;
  }

  .tabClass {
    position: relative;

    .notice {
      position: absolute;
      top: 10px;
      left: 60px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: red;
      text-align: center;
      color: #fff;
    }
  }
}
.headerClass {
  padding-left: 20px;
  background-color: #fafafa;
  min-height: 500px;
}

.topradio {
  height: 40px;
  width: 700px;
  line-height: 50px;
}
.raw {
  position: relative;
}
.input1 {
  width: 200px;
  display: inline-block;
  margin: 10px 10px;
  height: 30px;
  padding-left: 10px;
}
.input2 {
  width: 500px;
  display: inline-block;
  margin: 10px 10px;
  height: 30px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/front/document/components/debug.vue